// extracted by mini-css-extract-plugin
export default {"infoSection":"info_section-module___infoSection___ac7e5a6b","gray":"info_section-module___gray___cc937b68"};